var map = {
	"./add-event.svg": 2548,
	"./alm.svg": 5762,
	"./calendar-big.svg": 6241,
	"./calendar.svg": 1972,
	"./doors-img.svg": 1959,
	"./error.svg": 7620,
	"./forgot-password.svg": 6599,
	"./google-icon.svg": 7463,
	"./google-sync-icon.svg": 129,
	"./icon_calendar_sync.svg": 2268,
	"./link-sent-icon.svg": 5473,
	"./link-sent.svg": 3613,
	"./log-out.svg": 4075,
	"./login-image.svg": 4545,
	"./logo_calizy_pro.svg": 9376,
	"./marker.svg": 440,
	"./member-available-img.svg": 5332,
	"./outllook-sync-icon.svg": 2661,
	"./outlook-icon.svg": 4491,
	"./private-image.svg": 9515,
	"./warning-icon.svg": 9844,
	"./well-done.svg": 3359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6028;